import React from 'react';
import Account from './pages/Account';
import ProfilePage from './pages/ProfilePage';
import { RoutingStep } from 'router/models/Routes';
import { Navigate } from 'react-router-dom';
import PreferencesPage from './pages/PreferencesPage';
import BriefcaseIcon from 'icons/Briefcase.icon';
import ProfileIcon from 'icons/Profile.icon';
import SettingsIcon from 'icons/Settings.icon';

export default [
  {
    path: 'personal-details',
    element: ProfilePage,
    labelId: 'personalDetails',
    stepName: 'personalDetails',
    Icon: ProfileIcon,
  },
  {
    path: 'profile',
    element: PreferencesPage,
    labelId: 'preferences',
    stepName: 'preferences',
    Icon: BriefcaseIcon,
  },
  {
    path: 'account',
    element: Account,
    labelId: 'settings',
    stepName: 'account',
    Icon: SettingsIcon,
  },
  { index: true, element: <Navigate to="personal-details" replace /> },
] as Array<RoutingStep>;
